import React from "react";
import {
  FormContentInputField,
  FormContentInputFieldText,
  FormContentInputFieldError,
  FormContentInputFieldErrorText,
  FormContentFieldCaption,
  FormContentFieldCaptionText,
} from "../styles/LandingPageForm.styles";
import ErrorIcon from "../icons/ErrorIcon";

interface StylisedInputFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
  placeholder: string;
  captionText?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  errorMsg: string;
  forceError?: boolean;
  type?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  onClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const StylisedInputField = ({
  value,
  onChange,
  isDisabled = false,
  placeholder,
  captionText,
  startAdornment,
  endAdornment,
  errorMsg,
  forceError = false,
  type = "text",
  onFocus,
  onBlur,
  onClick,
  onKeyDown,
  inputRef,
}: StylisedInputFieldProps) => {
  const Caption = () => {
    return (
      <FormContentFieldCaption>
        <FormContentFieldCaptionText>{captionText}</FormContentFieldCaptionText>
      </FormContentFieldCaption>
    );
  };

  return (
    <>
      {value && captionText && <Caption />}
      <FormContentInputField onClick={onClick} isError={!!errorMsg || forceError}>
        {startAdornment != null && startAdornment}
        <FormContentInputFieldText
          ref={inputRef}
          disabled={isDisabled}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          type={type}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
        />
        {endAdornment != null && endAdornment}
      </FormContentInputField>
      {!!errorMsg && (
        <FormContentInputFieldError>
          <ErrorIcon />
          <FormContentInputFieldErrorText>{errorMsg}</FormContentInputFieldErrorText>
        </FormContentInputFieldError>
      )}
    </>
  );
};

export default StylisedInputField;
